export default "/images/dc1c417c6f14d90e541f9e145912af7b.jpg";